/* eslint-disable import/prefer-default-export */

import { wrapPageElement } from './gatsby-ssr';

export { wrapPageElement };

export const onRouteUpdate = (_, {
  assistantId,
  accessToken,
}) => {
  if (!assistantId || !accessToken) {
    console.error('Cannot re-init Autochat without assistantId or accessToken');
  }
  if (typeof autochat !== 'undefined') {
    // re-init for the actionbar to have new context
    autochat.init({
      assistantId,
      accessToken,
    });
  }
};
